<template>
  <div class="parallax-container">
    <ul class="container collapsible">
      <li class="active">
        <Travel />
      </li>
      <li>
        <Travelers />
      </li>
      <li>
        <Summary />
      </li>
    </ul>
    <div class="parallax">
      <img src="../assets/para-2.jpg" alt="Le Gombessa" />
    </div>


  </div>
</template>


<script>
import Travel from "@/components/reservation/Travel.vue";
import Travelers from "@/components/reservation/Travelers.vue";
import Summary from "@/components/reservation/Summary.vue";
import M from "materialize-css";

export default {
  components: {
    Travel,
    Travelers,
    Summary
  },
  mounted() {
    // collapsible, mobile menu
    M.AutoInit();
  }
};
</script>


<style scoped>
@media (max-width: 600px) {
  body .parallax-container {
    background-color: white !important;
  }
}
</style>